import React from 'react'
import PropType from 'prop-types'
import InfraFullLayer from './InfraFullLayer'
import ReduxProvider from './ReduxProvider'

function Root({
  children, theme, auth, message, withRedux, noAuth, reducers, middlewares, store, authUrl,
}) {
  return withRedux
    ? (
      <ReduxProvider store={store} reducers={reducers} middlewares={middlewares}>
        <InfraFullLayer
          message={message}
          auth={auth}
          theme={theme}
          noAuth={noAuth}
          authUrl={authUrl}
        >
          {children}
        </InfraFullLayer>
      </ReduxProvider>
    ) : (
      <InfraFullLayer message={message} auth={auth} theme={theme} noAuth={noAuth} authUrl={authUrl}>
        {children}
      </InfraFullLayer>
    )
}

Root.defaultProps = {
  withRedux: false,
  reducers: null,
  store: null,
  middlewares: [],
  noAuth: false,
  authUrl: '/auth',
}

Root.propTypes = {
  auth: PropType.string.isRequired,
  authUrl: PropType.string,
  children: PropType.node.isRequired,
  message: PropType.objectOf(PropType.any).isRequired,
  middlewares: PropType.arrayOf(PropType.object),
  noAuth: PropType.bool,
  reducers: PropType.objectOf(PropType.any),
  store: PropType.objectOf(PropType.any),
  theme: PropType.oneOfType([PropType.object, PropType.string]).isRequired,
  withRedux: PropType.bool,
}

export default Root
